var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('video-image');
import { breakpoints } from '@shapeable/theme';
import { EntityThumbnailImage } from './entity-image';
import { VideoPlayer } from '../elements/video-player';
import { useModal } from '../hooks/use-modal';
import { useVideoIcon } from '../context/video-icon-context';
import { Icon } from '../elements/icon';
export var VideoImageDefaultProps = {
  opacity: '22',
  color: '#000000',
  modalColor: '#000000'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    transition: filter 0.2s;\n\n    &:hover {\n      filter: brightness(1.2);\n    }\n  "], ["\n    width: 100%;\n    height: 100%;\n    transition: filter 0.2s;\n\n    &:hover {\n      filter: brightness(1.2);\n    }\n  "])))
});
var size = function (width) {
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n  "])), width, 9 / 16 * width);
};
var VideoStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #000;\n  box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "], ["\n  background: #000;\n  box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "])), size(320)),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(400)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(640)),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(980))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 50;\n    width: 100%;\n    height: 100%;\n    \n    &:hover {\n      filter: brightness(1.01);\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 50;\n    width: 100%;\n    height: 100%;\n    \n    &:hover {\n      filter: brightness(1.01);\n    }\n\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      _opacity = _a._opacity;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      background-color: ", "", ";\n    "], ["\n      background-color: ", "", ";\n    "])), _color, _opacity);
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: styled.button.attrs(cls.attr('button'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  IconContainer: styled(Icon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Image: styled(EntityThumbnailImage)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Video: styled(VideoPlayer)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), VideoStyles)
};
export var VideoImage = function (props) {
  var className = props.className,
    color = props.color,
    modalColor = props.modalColor,
    entity = props.entity,
    opacity = props.opacity,
    onClick = props.onClick;
  var modal = useModal();
  var Icon = useVideoIcon();
  var buttonOnClick = onClick || function () {
    modal.show(React.createElement(My.Video, {
      playing: true,
      url: entity.url
    }), {
      color: modalColor,
      title: entity.name
    });
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, {
    entity: entity
  }), React.createElement(My.Button, {
    _opacity: opacity,
    _color: color,
    onClick: buttonOnClick
  }, Icon && React.createElement(My.IconContainer, {
    color: "light",
    size: 64
  }, React.createElement(Icon, null))));
};
VideoImage.defaultProps = VideoImageDefaultProps;
VideoImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;